import Vue from 'vue'

import ElementUI from 'element-ui'
// import VCharts from 'v-charts'

import 'element-ui/lib/theme-chalk/index.css'
// import './theme/coocaa-red/index.css'
import './bus'

import AppState from '@william17/vue-app-state'
import '@ccprivate/admin-toolkit/dist/admin-toolkit.css'
import AdminTookit from '@ccprivate/admin-toolkit'
import cUtils from '@ccprivate/utils/dist/ccUtil.cjs'

import pagination from './components/pagination.vue'
import TimeFormat from './components/TimeFormat.vue'
import NumToText from './components/NumToText.vue'
import ChartWrapper from '@/components/ChartWrapper.vue'
import BlockBox from '@/components/BlockBox.vue'
import ManualIcon from '@/components/ManualIcon.vue'
import Progress from '@/components/Progress.vue'
import TargetRate from '@/components/TargetRate'
import checkUseragent from '@/utils/checkUseragent.js'
// import '@/assets/icon/iconfont.css'
import gutter from '@/utils/gutter'
import './auth'
import CCMap from '@ccos/ccmap'
import './assets/css/reset.css'
import lodash from 'lodash'
import { routeInfo } from '@/utils'
window.CCMap = CCMap

Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 }
Vue.prototype.$Gutter = gutter
Vue.prototype.$cUtils = cUtils
Vue.prototype.$isAndroid = checkUseragent()
Vue.prototype.$lodash = lodash
Vue.prototype.$routeInfo = routeInfo

Vue.component('pagination', pagination)
Vue.component('TimeFormat', TimeFormat)
Vue.component('NumToText', NumToText)
Vue.component('ChartWrapper', ChartWrapper)
Vue.component('CBlockBox', BlockBox)
Vue.component('CManualIcon', ManualIcon)
Vue.component('CProgress', Progress)
Vue.component('CTargetRate', TargetRate)

// Vue.use(VCharts)
Vue.use(ElementUI)
Vue.use(AppState)
Vue.use(AdminTookit)
